import { DateTime, Interval } from 'luxon';
import TempRedirPlan from './TempRedirPlan';
import Axios from 'axios';
 
export default{

    /**
     * Ajustando para pegar em dias o periodo da assinatura recorrente.
     * OBS: Teve que criar um Helper para ajustar o periodo, pois no office não é salvo como dias, e sim
     * como nomes para os periodos.
     *
     *
     * @param Periodo
     * @returns {number}
     */
    periodoRecorrente(Periodo){
        if(Periodo == 'MENSAL') return 1;
        if(Periodo == 'ANUAL')  return 12;
    },

    /**
     * 
     * Retorna as URLS dos aplicativos e o env conforme o ambiente em que esta
     * 
     * @returns {urlCheckout: '', urlOffice: '', env: '}
     */
    getEnvs(){
        const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

        //Host em rede local
        if(ipv4Regex.test(location.hostname)){
            let https = location.protocol == 'https:' ? 's' : '';

            return {
                urlCheckoutFront: location.hostname,
                urlCheckout: `http${https}://${location.hostname}:81`,
                urlOffice: `https://office.kub.app.builderall.io`,
                urlOfficeAdmin: 'http://www.omb100.local',
                urlTranslation: `http${https}://${location.hostname}:82`,
                urlLogs: `http${https}://${location.hostname}`,
                urlTracking: 'https://ot.builderall.io',
                urlWordpress: 'https://wordpress.builderall.io',
                urlCheetah: 'https://cheetah-api.builderall.info',
                webhookDefaultFee: 'http://www.omb100.local/us/notificacao-pagamento-franquia/builderall_gateway',
                webhookDefaultPlan: 'http://www.omb100.local/us/notificacao-pagamento-fatura-franquia/builderall_gateway',
                domainRegistry: 'https://domain-registry.kub.app.builderall.io',
                uiBendaKeys: {
                    publicKey: 'mEPYYz1q001o16nA3wRlu3CXUDZQ0v5h'
                },
                env: 'dev'
            }
        }

        //Local
        if(['localhost', 'checkout.builderall.local'].includes(location.hostname)){
            let https = location.protocol == 'https:' ? 's' : '';

            return {
                urlCheckoutFront: 'checkout.builderall.local',
                urlCheckout: `http${https}://api-payment.builderall.local`,
                urlOffice: `https://office.kub.app.builderall.io`,
                urlOfficeAdmin: 'http://www.omb100.local',
                urlTranslation: `http${https}://translation.builderall.local`,
                urlLogs: `http${https}://logger.builderall.local`,
                urlTracking: 'https://ot.builderall.io',
                urlWordpress: 'https://wordpress.builderall.io',
                urlCheetah: 'https://cheetah-api.builderall.info',
                webhookDefaultFee: 'http://www.omb100.local/us/notificacao-pagamento-franquia/builderall_gateway',
                webhookDefaultPlan: 'http://www.omb100.local/us/notificacao-pagamento-fatura-franquia/builderall_gateway',
                domainRegistry: 'https://domain-registry.kub.app.builderall.io',
                uiBendaKeys: {
                    publicKey: 'mEPYYz1q001o16nA3wRlu3CXUDZQ0v5h'
                },
                env: 'dev'
            }
        }
    
        //Test .io
        if(['checkout.builderall.io', 'checkoutfront.kub.app.builderall.io'].includes(location.hostname)){
            return {
                urlCheckoutFront: 'checkoutfront.kub.app.builderall.io',
                urlCheckout: 'https://checkoutback.kub.app.builderall.io',
                urlOffice: 'https://office.kub.app.builderall.io',
                urlOfficeAdmin: 'https://www.admin.kub.app.builderall.io',
                urlTranslation: 'https://translation.builderall.com',
                urlLogs: 'https://logger.builderall.com',
                urlTracking: 'https://ot.kub.app.builderall.io',
                urlMicroserviceDebitedBuilderall: 'https://microservice.builderall.io',
                urlWordpress: 'https://wordpress.builderall.io',
                urlCheetah: 'https://cheetah-api.builderall.info',
                webhookDefaultFee: 'http://www.omb1000.com/us/notificacao-pagamento-franquia/builderall_gateway',
                webhookDefaultPlan: 'http://www.omb1000.com/us/notificacao-pagamento-fatura-franquia/builderall_gateway',
                domainRegistry: 'https://domain-registry.kub.app.builderall.io',
                uiBendaKeys: {
                    publicKey: 'mEPYYz1q001o16nA3wRlu3CXUDZQ0v5h'
                },
                env: 'test'
            }
        }

        //Homolog
        if(['checkout.builderall.info', 'checkoutfront.kub.app.builderall.info'].includes(location.hostname)){
            return {
                urlCheckoutFront: 'checkout.builderall.info',
                urlCheckout: 'https://checkoutback.kub.app.builderall.info',
                urlOffice: 'https://office.kub.app.builderall.info',
                urlOfficeAdmin: 'https://www.admin.kub.app.builderall.info',
                urlTranslation: 'https://translation.builderall.com',
                urlLogs: 'https://logger.builderall.com',
                urlTracking: 'https://ot.kub.app.builderall.info',
                urlMicroserviceDebitedBuilderall: 'https://microservice.builderall.com',
                urlWordpress: 'https://wordpress.builderall.com',
                urlCheetah: 'https://cheetah-api.builderall.info',
                webhookDefaultFee: 'http://www.omb100.com/us/notificacao-pagamento-franquia/builderall_gateway',
                webhookDefaultPlan: 'http://www.omb100.com/us/notificacao-pagamento-fatura-franquia/builderall_gateway',
                domainRegistry: 'https://domain-registry.kub.app.builderall.info',
                uiBendaKeys: {
                    publicKey: '1Id8QTPw8ke5T45yWzNMSoYN6y1VUJyu'
                },
                env: 'info'
            }
        }

        //Checkout V3
        if(['checkoutv3.builderall.io'].includes(location.hostname)){
            return {
                urlCheckoutFront: 'checkoutv3.builderall.io',
                urlCheckout: 'https://checkoutback.kub.app.builderall.io',
                urlOffice: 'https://office.kub.app.builderall.io',
                urlOfficeAdmin: 'https://www.admin.kub.app.builderall.io',
                urlTranslation: 'https://translation.builderall.io',
                urlLogs: 'https://logger.builderall.com',
                urlTracking: 'https://ot.builderall.io',
                urlMicroserviceDebitedBuilderall: 'https://microservice.builderall.io',
                urlWordpress: 'https://wordpress.builderall.io',
                urlCheetah: 'https://cheetah-api.builderall.info',
                webhookDefaultFee: 'http://www.omb1000.com/us/notificacao-pagamento-franquia/builderall_gateway',
                webhookDefaultPlan: 'http://www.omb1000.com/us/notificacao-pagamento-fatura-franquia/builderall_gateway',
                domainRegistry: 'https://domain-registry.kub.app.builderall.io',
                uiBendaKeys: {
                    publicKey: 'mEPYYz1q001o16nA3wRlu3CXUDZQ0v5h'
                },
                env: 'test'
            }
        }

        //Produção
        if(['checkout.builderall.com', 'checkoutv3.builderall.com', 'checkoutfront.kub.app.builderall.com'].includes(location.hostname)){
            return {
                urlCheckoutFront: 'checkout.builderall.com',
                urlCheckout: 'https://api-payment.builderall.com',
                urlOffice: 'https://office.builderall.com',
                urlOfficeAdmin: 'https://www.omb100.com',
                urlTranslation: 'https://translation.builderall.com',
                urlLogs: 'https://logger.builderall.com',
                urlTracking: 'https://ot.builderall.com',
                urlMicroserviceDebitedBuilderall: 'https://microservice.builderall.com',
                urlWordpress: 'https://wordpress.builderall.com',
                urlCheetah: 'https://cheetah-api.builderall.com',
                webhookDefaultFee: 'http://www.omb100.com/us/notificacao-pagamento-franquia/builderall_gateway',
                webhookDefaultPlan: 'http://www.omb100.com/us/notificacao-pagamento-fatura-franquia/builderall_gateway',
                domainRegistry: 'https://domain-registry.builderall.com',
                uiBendaKeys: {
                    publicKey: '1Id8QTPw8ke5T45yWzNMSoYN6y1VUJyu'
                },
                env: 'prod'
            }
        }
    },

    /**
     * Insere o script do AppShell no HTML baseado no ambiente
     *
     * @returns {void}
     */
    loadAppShellScript(){
        const env = this.getEnvs().env;
        const scriptUrl = env === 'prod'
            ? 'https://js.builderall.com/builderall.js'
            : 'https://appshell.kub.app.builderall.io/builderall.js';

        const script = document.createElement('script');
        script.src = scriptUrl;
        script.async = true;

        document.head.appendChild(script);
    },

    /**
     * Converte a palavra para ser chave para tradução. 
     * @param Palavra
     * @returns {string}
     */
    transformePalavraTraducao(Palavra){
        return Palavra.toLowerCase()
            .replace(/<(.*?)>/g, '') //Remove tags HTML
            .replace(/({[\d]})(\W)/g, '') //Remove interpolações
            .replace(/[^a-z0-9]/g, ' ') //Apenas letras/numeros
            .replace(/\s+/g, ' ') //Remove espaços duplos
            .replace(/\s/g, '_'); //Transforma espaços em _
    },

    /**
     * Retorna um array com todas as siglas disponveis do office
     * 
     * @returns {array}
     */
    siglasOffice(){
        return ['us','br','ir','de','gb','nl','ee','au','es','pt','dk','lt','bo','pe','py','fr','pl','it','mx','no','ar','cr','co','ec','ve','cl','gt','il','ru','si','ro','vi','hu','cn','hi','ko','bn','th','el','fa','ja'];    
    },
    
    /**
     * Converte a sigla do pais do office, para sigla correta da API de tradução do checkout da builderall.
     * 
     * @param Sigla
     */
    convertSigla(Sigla){
        if(Sigla == 'br') return 'pt';
        if(Sigla == 'us') return 'en';
        if(Sigla == 'il') return 'iw';
        if(Sigla == 'he') return 'iw';
        if(Sigla == 'ro') return 'en';
        
        return Sigla;
    },

    /**
     * Converte a sigla do checkout(browser), para siglas do office.
     *
     * @param Sigla
     */
    convertCountryCodeToOffice(countryCode){
        if(countryCode == 'pt') return 'br';

        return countryCode;
    },
    
    langDefault: 'en',

    /**
     * 7 é o valor do builderall gateway
     */
    builderallGatewayId: 7,

    /**
     * Versao de tradução do checkout
     */
    translateVersion: 'builderall_checkout_v3',

    /**
     * List Accounts Builderall
     */
    builderallAccounts: {
        internetMarketingLLC_10: '10',
        internetMarketingLLC_30877: '30877',
        internetMarketingLLC_209282: '209282',
        impact_2494737: '2494737'
    },

    /**
     * Pega a sigla do browser do usuario, por padrão a sigla é en (English)
     * 
     * @returns {string}
     */
    getLangBrowser(){
        let lang = 'en';
        
        if(navigator.language){
            lang = navigator.language.substring(0, 2);    
        }
        
        return lang;
    },

    /**
     * Retorna a URL do office, conforme a linguagem do browser
     * 
     * @param Endpoint
     * @returns {string}
     */
    getUrlOffice(Endpoint){
        let langBrowser = this.getLangBrowser();
        
        let langOffice = this.siglasOffice().find(item => {
            let convertSigla = this.convertSigla(item);
            if(convertSigla == langBrowser){
                return item;
            }
        });
        
        //Caso o linguagem for indefinida, deixa o default com US
        if(langOffice === undefined) langOffice = 'us';
        if(langBrowser == 'he') langOffice = 'il';
        
        return `${this.getEnvs().urlOffice}/${langOffice}/${Endpoint}`;
    },

    /**
     * Retorna os tipos de moedas disponiveis para pagamentos no checkout
     * 
     * @returns {string[]}
     */
    getCurrencyAcceppt(){
        return [
            'AED', 'ARS', 'AUD', 'BRL', 'CAD', 'CHF', 'CLP', 'COP', 'CZK', 'DKK', 'EGP', 'EUR', 'GBP', 'HKD', 'HUF', 'INR', 'IDR', 'ILS', 'JPY', 'KES', 'KRW', 'MYR', 'MXN', 'MAD', 'NZD', 'NGN', 'NOK', 'PKR', 'PEN', 'PHP', 'PLN', 'SAR', 'SEK', 'SGD', 'THB', 'TRY', 'TWD', 'USD', 'VND', 'ZAR'
        ];
    },

    /**
     * Total de tentativas de pagamento com possivel fraude.
     * 
     */
    possibleFraudAttempts: 3,

    /**
     * Lista de codigos dos paises da europa que precisam de VAT
     * 
     * 
     * @TODO Retornar do banco de dados os codigos dos paises, e adicionar no store
     */
    listCountryEurope: [
        "SK","SI","SE","RO","PT","PL","NL","MT","LV","LU","LT","IT","IE","HU","HR","GR","GB","FR","FI","ES","EE","DK","DE","CZ","CY","BG","BE","AT"
    ],

    countryDutch: 'NL',
    
    /**
     * Calcular VAT
     * 
     * @param Amount Valor do produto
     * @returns {number} Retorna o valor da taxa(VAT) aplicada
     */
    calculateVat(Amount, Percentage){
        return ((Amount * Percentage) / 100).toFixed(2); 
    },

    /**
     * Formata o valor para exibição total de desconto
     * 
     * @param PlanOrFeeAmount
     * @param ValueDiscount
     * @param Type
     * @returns {number}
     */
    calcDiscount(PlanOrFeeAmount, ValueDiscount, Type)
    {
        switch(Type){
            case 'FIXED_VALUE':
                return ValueDiscount;
            break;

            case 'PERCENTAGE_OF_DISCOUNT':
                return (PlanOrFeeAmount - ((PlanOrFeeAmount * ValueDiscount) / 100)).toFixed(2);
            break;
        }
    },

    formatValueDiscount(PlanOrFeeAmount, ValueDiscount, Type)
    {
        switch(Type){
            case 'FIXED_VALUE':
                return ValueDiscount;
            break;

            case 'PERCENTAGE_OF_DISCOUNT':
                return ValueDiscount;
            break;
        }
    },

    /**
     * Adds or updates a URL parameter.
     *
     * @param {string} url  the URL to modify
     * @param {string} param  the name of the parameter
     * @param {string} paramVal  the new value for the parameter
     * @return {string}  the updated URL
     */
    setUrlParam(url, param, paramVal, setHowLast) {
        var urlSplited = url.split('#'),
            parts = urlSplited[0].split('?'),
            baseUrl = parts[0],
            newParameters = [];
        // cast boolean
        setHowLast = !!setHowLast;
        if (!setHowLast) {
            if (paramVal !== '' && paramVal !== null && typeof paramVal !== 'undefined') {
                var paramValue = param == 'redir' ? paramVal : encodeURI(paramVal);
                newParameters.push(param + '=' + paramValue);
            }
        }
        for (var i = 1, len = parts.length; i < len; i++) {
            var oldQueryString = parts[i];
            if (!!oldQueryString) {
                var oldParameters = oldQueryString.split('&');
                for (var i = 0; i < oldParameters.length; i++) {
                    if (oldParameters[i].split('=')[0] != param) {
                        newParameters.push(oldParameters[i]);
                    }
                }
            }
        }
        if (setHowLast) {
            if (paramVal !== '' && paramVal !== null && typeof paramVal !== 'undefined') {
                var paramValue = param == 'redir' ? paramVal : encodeURI(paramVal);
                newParameters.push(param + '=' + paramValue);
            }
        }
        if (newParameters.length > 0) {
            baseUrl += '?' + newParameters.join('&');
        }
        if (urlSplited.length == 2) {
            baseUrl += '#' + urlSplited[1];
        }
        return baseUrl;
    },
    urlSetParam(param, value)
    {
        let url = new URL(window.location.href);

        url.searchParams.set(param, value);

        window.history.replaceState(null, '', url);
    },
    serialize(obj, prefix){
        var str = [], p;
        for (p in obj) {
            if (obj.hasOwnProperty(p)) {
                var k = prefix ? prefix + '[' + p + ']' : p,
                    v = obj[p];
                str.push(
                    (v !== null && typeof v === 'object')
                        ? this.serialize(v, k)
                        : encodeURIComponent(k) + '=' + encodeURIComponent(v)
                );
            }
        }
        return str.join('&');
    },
    getAidOffice(){
        var hash         = location.hash,
            hasHash      = !!hash.length,
            _idPaiOffice = null,
            match = null;

        if (hasHash) {
            if (match = hash.match(/aid=([0-9]+)/)) {
                _idPaiOffice = match[1];
            }
        }

        return _idPaiOffice;
    },
    getParamHash(name){
        let urlWithHash = new URLSearchParams(decodeURIComponent(location.hash.replace('#', '')));

        return urlWithHash.get(name) ? urlWithHash.get(name) : false;
    },
    setBuilderallPixel(aid, lang, subdomain){
        if(!!aid) {
            let params = {
                query: 'p1=rd&p2=https://' + location.hostname,
                id_user_office: aid
            };
            (function (image, params, hostname, referrer, urlCheckout, urlTracking) {
                let url    = '//{domain}/{lang}/franchise/share/{id}?noredirect&from={hostname}&{query}&{page_or_sd}',
                    query  = params.query,
                    domain = `${urlTracking.substr(8)}/api/v1`; //Utiliza o substr para remover o https

                if(location.search.length) {
                    query += location.search.replace('?', '&');
                }

                let regexCheckout = new RegExp(`^${urlCheckout}$`);
                if (regexCheckout.test(hostname) && referrer) {
                    let rgx = /^https?\:\/\/?(([\w+\.\-]+))/;
                    hostname = referrer.match(rgx)[1];
                }

                if (params.id_user_office) {
                    image.src = url.replace('{id}', params.id_user_office)
                        .replace('{domain}', domain)
                        .replace('{query}', query)
                        .replace('{hostname}', hostname)
                        .replace('{lang}', lang)
                        .replace('{page_or_sd}', `${subdomain == null ? `page=${window.location.hostname}${window.location.pathname}` : `sd=${subdomain}`}`);
                }
            })(new Image(), params, location.hostname, document.referrer, this.getEnvs().urlCheckoutFront, this.getEnvs().urlTracking);
        }
    },
    setPixelBuilderallFinishPayment(UserId, UrlAfterPayment, ClickedBtnGoUrl = false){
        
        if(ClickedBtnGoUrl){
            (function (image, Env) {
                var url    = '//{domain}/us/funnel-continue-wipe',
                    domain = Env == 'prod' ? 'office.builderall.com' : 'office.kub.app.builderall.io';
                image.src = url.replace('{domain}', domain);
            })(new Image(), this.getEnvs().env);
            
            return;
        }
        
        (function (image, userId, urlAfterPayment, Env) {
            var url    = '//{domain}/us/funnel-continue/{id}?continue-url={url}',
                domain = Env == 'prod' ? 'office.builderall.com' : 'office.kub.app.builderall.io';
            image.src = url.replace('{id}', userId)
                .replace('{domain}', domain)
                .replace('{url}', urlAfterPayment);
        })(new Image(), UserId, UrlAfterPayment, this.getEnvs().env);  
    },
    isMobile(){
        if( navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i)
        ){
            return true;
        }
        else {
            return false;
        }
    },
    /**
     * 
     * @param StartDate
     * @param EndDate
     * @returns {{days: number, months: number, years: number}}
     */
    intervalBetweenDates(StartDate, EndDate){
        let dateStart = DateTime.fromISO(StartDate);
        let dateNow = EndDate == undefined ? DateTime.local() : DateTime.fromISO(EndDate);
        let interval = Interval.fromDateTimes(dateStart, dateNow);
        
        return {
            days: interval.count('days'),
            months: interval.count('months'),
            years: interval.count('years')
        }
    },
    firstName(fullName){
        return fullName.indexOf(' ') != -1 ? fullName.substr(0, fullName.indexOf(' ')).trim() : fullName;
    },
    lastName(fullName){
        return fullName.indexOf(' ') != -1 ? fullName.substr(fullName.indexOf(' ')).trim() : null;
    },
    slugsPlansWordpressCloud: [
        'wp-basic-usd',
        'wp-essential-usd',
        'wp-ultra-usd',
        'wp-hyper-usd',
        'wp-elite-usd',

        'wp-basic-eur',
        'wp-essential-eur',
        'wp-ultra-eur',
        'wp-hyper-eur',
        'wp-elite-eur',

        'wp-basic-vip-brl',
        'wp-basic-brl',
        'wp-essential-brl',
        'wp-ultra-brl',
        'wp-hyper-brl',
        'wp-elite-brl'
    ],
    slugsUpwork: [
        //Fees
        'fee-website-creation-basic',
        'fee-website-creation-standard',
        'fee-website-creation-premium',
        'fee-marketing-automation-basic',
        'fee-marketing-automation-standard',
        'ee-marketing-automation-premium',
        'fee-sales-funnel-basic',
        'fee-sales-funnel-standard',
        'fee-sales-funnel-premium',

        //Plans
        'core-website-creation-basic',
        'essential-website-creation-standard',
        'advanced-website-creation-premium',
        'essentials-marketing-automation-basic',
        'advanced-marketing-automation-standard',
        'advanced-marketing-automation-premium',
        'advanced-sales-funnel-basic',
        'advanced-sales-funnel-standard',
        'premium-sales-funnel-premium'
    ],
    slugsNotUseCoupon: [
        'cnces-essentials-plan',
        'cnces-advanced-plan',
        'cnces-premium-plan',
        '90launch-system-plan',
        'build-win-plan'
    ],
    slugsAgency: [
        'website-agency-brl',
        'website-agency-usd',
        'website-agency-eur'
    ],
    slugsLaunchSystemPlan: [
        '90launch-system-plan',
        'build-win-plan'
    ],
    slugsAllowedForLaunchSystem: [
        'test-brl',
        'test-usd',
        'test-eur',
        'essentials-plan-trial',
        'advanced-plan-trial',
        'premium-plus-plan-trial',
        'free-brl',
        'free-usd',
        'free-eur',
        'core-account-trial',
        'core-account',
        'bundle-plan'
    ],
    launchSystemPlanAmounts: {
        BR: { currency: 'BRL', first_payment: '139.00', recurring: '190.00' },
        US: { currency: 'USD', first_payment: '49.00',  recurring: '67.00'  },
        DE: { currency: 'EUR', first_payment: '40.00',  recurring: '55.00'  },
        MX: { currency: 'MXN', first_payment: '740.00', recurring: '1012.00' },
        IT: { currency: 'EUR', first_payment: '40.00',  recurring: '55.00'  },
        ES: { currency: 'EUR', first_payment: '40.00',  recurring: '55.00'  },
        CO: { currency: 'COP', first_payment: '77464.00', recurring: '105924.00' },
        CA: { currency: 'CAD', first_payment: '59.00',  recurring: '81.00'  },
        GB: { currency: 'GBP', first_payment: '37.00',  recurring: '51.00'  },
        AU: { currency: 'AUD', first_payment: '64.00',  recurring: '88.00'  },
        AR: { currency: 'ARS', first_payment: '20141.00', recurring: '27541.00' },
        FR: { currency: 'EUR', first_payment: '42.00',  recurring: '57.00'  },
        PE: { currency: 'PEN', first_payment: '127.00', recurring: '174.00' },
        VE: { currency: 'USD', first_payment: '22.00',  recurring: '30.00'  },
        AT: { currency: 'EUR', first_payment: '40.00',  recurring: '55.00'  },
        BE: { currency: 'EUR', first_payment: '42.00',  recurring: '57.00'  },
        BO: { currency: 'USD', first_payment: '22.00',  recurring: '30.00'  },
        CL: { currency: 'USD', first_payment: '37.00',  recurring: '51.00'  },
        CR: { currency: 'USD', first_payment: '47.00',  recurring: '64.00'  },
        DO: { currency: 'USD', first_payment: '29.00',  recurring: '40.00'  },
        EC: { currency: 'USD', first_payment: '29.00',  recurring: '40.00'  },
        EG: { currency: 'EGP', first_payment: '440.00', recurring: '602.00' },
        SV: { currency: 'USD', first_payment: '29.00',  recurring: '40.00'  },
        FI: { currency: 'EUR', first_payment: '36.00',  recurring: '49.00'  },
        GR: { currency: 'EUR', first_payment: '33.00',  recurring: '45.00'  },
        GT: { currency: 'USD', first_payment: '29.00',  recurring: '40.00'  },
        HU: { currency: 'HUF', first_payment: '12661.00', recurring: '17313.00' },
        IN: { currency: 'INR', first_payment: '1816.00', recurring: '2483.00' },
        IE: { currency: 'EUR', first_payment: '46.00',  recurring: '63.00'  },
        IL: { currency: 'ILS', first_payment: '200.00', recurring: '273.00' },
        JP: { currency: 'USD', first_payment: '37.00',  recurring: '51.00'  },
        MY: { currency: 'MYR', first_payment: '175.00', recurring: '239.00' },
        NL: { currency: 'EUR', first_payment: '36.00',  recurring: '49.00'  },
        NZ: { currency: 'NZD', first_payment: '67.00',  recurring: '92.00'  },
        NI: { currency: 'USD', first_payment: '22.00',  recurring: '30.00'  },
        NG: { currency: 'NGN', first_payment: '39880.00', recurring: '54532.00' },
        NO: { currency: 'NOK', first_payment: '403.00', recurring: '551.00' },
        PA: { currency: 'USD', first_payment: '32.00',  recurring: '44.00'  },
        PY: { currency: 'USD', first_payment: '22.00',  recurring: '30.00'  },
        PH: { currency: 'PHP', first_payment: '1475.00', recurring: '2017.00' },
        PT: { currency: 'EUR', first_payment: '36.00',  recurring: '49.00'  },
        PR: { currency: 'USD', first_payment: '49.00',  recurring: '67.00'  },
        RO: { currency: 'EUR', first_payment: '30.00',  recurring: '41.00'  },
        SG: { currency: 'SGD', first_payment: '64.00',  recurring: '88.00'  },
        SK: { currency: 'EUR', first_payment: '30.00',  recurring: '41.00'  },
        ZA: { currency: 'ZAR', first_payment: '603.00', recurring: '825.00' },
        SE: { currency: 'SEK', first_payment: '470.00', recurring: '643.00' },
        CH: { currency: 'EUR', first_payment: '55.00',  recurring: '75.00'  },
        TW: { currency: 'TWD', first_payment: '1081.00', recurring: '1478.00' },
        TR: { currency: 'TRY', first_payment: '579.00', recurring: '792.00' },
        AE: { currency: 'AED', first_payment: '141.00', recurring: '193.00' },
        UY: { currency: 'USD', first_payment: '47.00',  recurring: '64.00'  },
        VN: { currency: 'USD', first_payment: '32.00',  recurring: '44.00'  }
    },
    //build-win-plan: mesmos valores do 90launch-system-plan, mudando apenas o first_payment
    buildWinPlanAmounts: {
        BR: { currency: 'BRL', first_payment: '246.00', recurring: '190.00' },
        US: { currency: 'USD', first_payment: '87.00',  recurring: '67.00'  },
        DE: { currency: 'EUR', first_payment: '71.00',  recurring: '55.00'  },
        MX: { currency: 'MXN', first_payment: '1310.00', recurring: '1012.00' },
        IT: { currency: 'EUR', first_payment: '71.00',  recurring: '55.00'  },
        ES: { currency: 'EUR', first_payment: '71.00',  recurring: '55.00'  },
        CO: { currency: 'COP', first_payment: '137111.00', recurring: '105924.00' },
        CA: { currency: 'CAD', first_payment: '104.00', recurring: '81.00'  },
        GB: { currency: 'GBP', first_payment: '65.00',  recurring: '51.00'  },
        AU: { currency: 'AUD', first_payment: '113.00', recurring: '88.00'  },
        AR: { currency: 'ARS', first_payment: '35650.00', recurring: '27541.00' },
        FR: { currency: 'EUR', first_payment: '74.00',  recurring: '57.00'  },
        PE: { currency: 'PEN', first_payment: '225.00', recurring: '174.00' },
        VE: { currency: 'USD', first_payment: '39.00',  recurring: '30.00'  },
        AT: { currency: 'EUR', first_payment: '71.00',  recurring: '55.00'  },
        BE: { currency: 'EUR', first_payment: '74.00',  recurring: '57.00'  },
        BO: { currency: 'USD', first_payment: '39.00',  recurring: '30.00'  },
        CL: { currency: 'USD', first_payment: '65.00',  recurring: '51.00'  },
        CR: { currency: 'USD', first_payment: '83.00',  recurring: '64.00'  },
        DO: { currency: 'USD', first_payment: '51.00',  recurring: '40.00'  },
        EC: { currency: 'USD', first_payment: '51.00',  recurring: '40.00'  },
        EG: { currency: 'EGP', first_payment: '779.00', recurring: '602.00' },
        SV: { currency: 'USD', first_payment: '51.00',  recurring: '40.00'  },
        FI: { currency: 'EUR', first_payment: '64.00',  recurring: '49.00'  },
        GR: { currency: 'EUR', first_payment: '58.00',  recurring: '45.00'  },
        GT: { currency: 'USD', first_payment: '51.00',  recurring: '40.00'  },
        HU: { currency: 'HUF', first_payment: '22410.00', recurring: '17313.00' },
        IN: { currency: 'INR', first_payment: '3214.00', recurring: '2483.00' },
        IE: { currency: 'EUR', first_payment: '81.00',  recurring: '63.00'  },
        IL: { currency: 'ILS', first_payment: '354.00', recurring: '273.00' },
        JP: { currency: 'USD', first_payment: '65.00',  recurring: '51.00'  },
        MY: { currency: 'MYR', first_payment: '310.00', recurring: '239.00' },
        NL: { currency: 'EUR', first_payment: '64.00',  recurring: '49.00'  },
        NZ: { currency: 'NZD', first_payment: '119.00', recurring: '92.00'  },
        NI: { currency: 'USD', first_payment: '39.00',  recurring: '30.00'  },
        NG: { currency: 'NGN', first_payment: '70588.00', recurring: '54532.00' },
        NO: { currency: 'NOK', first_payment: '713.00', recurring: '551.00' },
        PA: { currency: 'USD', first_payment: '57.00',  recurring: '44.00'  },
        PY: { currency: 'USD', first_payment: '39.00',  recurring: '30.00'  },
        PH: { currency: 'PHP', first_payment: '2611.00', recurring: '2017.00' },
        PT: { currency: 'EUR', first_payment: '64.00',  recurring: '49.00'  },
        PR: { currency: 'USD', first_payment: '87.00',  recurring: '67.00'  },
        RO: { currency: 'EUR', first_payment: '53.00',  recurring: '41.00'  },
        SG: { currency: 'SGD', first_payment: '113.00', recurring: '88.00'  },
        SK: { currency: 'EUR', first_payment: '53.00',  recurring: '41.00'  },
        ZA: { currency: 'ZAR', first_payment: '1067.00', recurring: '825.00' },
        SE: { currency: 'SEK', first_payment: '832.00', recurring: '643.00' },
        CH: { currency: 'EUR', first_payment: '97.00',  recurring: '75.00'  },
        TW: { currency: 'TWD', first_payment: '1913.00', recurring: '1478.00' },
        TR: { currency: 'TRY', first_payment: '1025.00', recurring: '792.00' },
        AE: { currency: 'AED', first_payment: '250.00', recurring: '193.00' },
        UY: { currency: 'USD', first_payment: '83.00',  recurring: '64.00'  },
        VN: { currency: 'USD', first_payment: '57.00',  recurring: '44.00'  }
    },
    slugCheetahTemplate: 'premium-template',
    slugBuyDomain: 'buy-domain', //TODO Foi feito o slugBuyDomainRegistry. Pode remover apos subir para produção o novo.
    slugBuyStorage: 'buy-storage',
    slugBuyDomainExtraConnection: 'buy-domain-extra-connection',
    slugBuyDomainRegistry: 'domain',
    /**
     * 
     * @param SlugUrlAccess
     * @param User
     * @param UserFather
     * @returns {string} planOrFeeInactive | tempRedir | office
     */
    redirUserPlanTrialOrPromotional(SlugUrlAccess, User, UserFather){
        let planStyle = TempRedirPlan.verifyAccessUserPlan(SlugUrlAccess, User.currency_code);

        //Logica realizada pq os disparos dos e-mail foi feito errado. E so pode comprar novamente quem ja esta no plano promotional
        if(
            (planStyle == 'NICHE') ||
            (planStyle == 'PROMOTIONAL' && TempRedirPlan.isRedirUser() && !['promotional-premium-usd-9', 'promotional-premium-eur-9', 'promotional-premium-brl-19'].includes(User.current_plan['slug']))
        ){
            return 'planOrFeeInactive';
        }

        //Slugs que nao sao de vendas, apenas cadastro
        if(planStyle == 'PREMIUMTRIAL' && ['test-brl', 'test-usd', 'test-eur'].includes(SlugUrlAccess)){
            return 'tempRedir';
        }

        //Regrar para os planos Premium Trial
        if(['premium-trial-usd-69', 'premium-trial-eur-59', 'premium-trial-brl-149', 'advanced-plan-trial'].includes(SlugUrlAccess)){
            //Se o usuario esta no plano free pode comprar
            if(['free-brl', 'free-usd', 'free-eur', 'free-czk', 'free-thb', 'free-inr'].includes(User.current_plan['slug'])) return 'doNotRedirect';

            //Se o usuario ja esta no trial e nao tem o support-link ou pay-now na url. faz o redirecionamento para o premium
            if(planStyle == 'PREMIUMTRIAL' && ['premium-trial-usd-69', 'premium-trial-eur-59', 'premium-trial-brl-149', 'premium-trial-30-brl', 'premium-trial-30-usd', 'premium-trial-30-eur', 'advanced-plan-trial'].includes(User.current_plan['slug'])){
                return 'tempRedir';
            }

            //Qual outro plano que estiver, faz redir para o office
            return 'office';
        }
    },
    validateVat(vat){
        return (RegExp(/^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$/))
            .test(vat)
    },
    filterToolsList(listTool){
        let namesToolRemove = [
            'WhatsApp',
            'Builderall Whatsapp Automation Tool',
            'BuilderZap',
            'BuilderallZap',
            'WhatsApp Launch Manager',
            'Gestionnaire de lancement WhatsApp',
        ];

        return listTool.filter(tool => !namesToolRemove.includes(tool))
    },
    convertNumber(number){
        let lang = navigator.language || 'en';

        return (new Intl.NumberFormat(lang).format(number))
    },
    getContactEmailBuilderall(){
        return this.getLangBrowser() == 'pt' ? 'contato@builderall.com' : 'contact@builderall.com'
    },
    convertGb(storage_kb){
        return (storage_kb / 1024 / 1024);
    },
    getPgm() 
    {
        if(sessionStorage.getItem('pgm')) return sessionStorage.getItem('pgm');

        return Math.random().toString(36).substr(2, 16) + (new Date()).getTime();
    },
    appendPgm() 
    {
        const url = new URL(window.location);

        if (!url.searchParams.has('pgm')) {
            let pgmHash = this.getPgm();

            url.searchParams.append('pgm', pgmHash);

            window.history.pushState(null, null, url.toString());

            sessionStorage.setItem('pgm', pgmHash);
        }
    },
    getNewNameCouponSuper(coupon, slug)
    {
        let data = {
            hasNewNameCoupon: false,
            newCoupon: ''
        }
        
        if(['SUPER'].includes(coupon.toUpperCase()) && slug == 'core-account') {
            data.hasNewNameCoupon = true;
            data.newCoupon = 'SUPER';
        }

        if(['SUPER', 'SUPER1'].includes(coupon.toUpperCase()) && ['essentials-plan', 'wp-essentials-plan'].includes(slug)) {
            data.hasNewNameCoupon = true;
            data.newCoupon = 'SUPER1';
        }

        if(['SUPER', 'SUPER2'].includes(coupon.toUpperCase()) && ['advanced-plan', 'wp-advanced-plan'].includes(slug)) {
            data.hasNewNameCoupon = true;
            data.newCoupon = 'SUPER2';
        }

        if(['SUPER', 'SUPER3'].includes(coupon.toUpperCase()) && ['premium-plus-plan', 'wp-premium-plus-plan'].includes(slug)) {
            data.hasNewNameCoupon = true;
            data.newCoupon = 'SUPER3';
        }

        return data;
    },

    payuCurrency: {
        ARS: 'ARS', //Argentina
        CLP: 'CLP', //Chile
        COP: 'COP', //Colombia
        MEX: 'MEX', //Mexico
        PEN: 'PEN' //Peru
    }
}